const baseApi = {};
baseApi.baseurl = process.env.REACT_APP_BASE_URL; // backend url
// baseApi.baseurl =
//   "https://server.qodequay.com/tajurba/dev/api/api/apppipeline/";
// baseApi.baseurl = "https://e27a-103-239-87-229.ngrok-free.app/api/apppipeline/";

export default baseApi;
